import { getUserId } from "@/services/supabase/auth/actions/getUserId";
import { supabase } from "@/services/supabase/createClient";
import { useQuery } from "@tanstack/react-query";
import { UserSettings } from "../types";

const getUserSettings = async () => {
  const userId = await getUserId();

  const { data, error } = await supabase.from("users").select("settings").eq("user_id", userId).single();

  if (error) {
    throw new Error(error.message);
  }

  return data.settings as unknown as UserSettings;
};

export const useUserSettings = () => {
  return useQuery({
    queryKey: ["user_settings"],
    queryFn: () => getUserSettings(),
  });
};
